import { get, post, patch } from "@/lib/fetcher";

/**
 * Fetch all compliance documents
 */
export async function getCompliances() {
    return await get("/admin/compliances");
}

/**
 * Create a new compliance document
 * @param {Object} data - { name }
 */
export async function postCompliance(data) {
    return await post("/admin/compliances", { compliance: data });
}

/**
 * Update a compliance document by ID
 * @param {string|number} id
 * @param {Object} data - fields to update
 */
export async function patchCompliance(id, data) {
    return await patch("/admin/compliances", id, { compliance: data });
}
